export default __webpack_public_path__ + "static/media/@jesstolledoo.c11469cd.jpg";